(ns app.front.requirement.events
  (:require [app.domain.group.plan-review-integration-model :as plan-review-integration-model]
            [app.front.process :as process]
            [app.front.util :as futil]
            [app.front.view.workspace.get :as ws-get]
            [cljs.reader :as edn]
            [core.db.entity.util :as eu]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::add-attachment-requirement
  (fn [{:keys [db]} [_ target-id attachment-type review-id]]
    (let [signal (if review-id
                   :process.signal/add-attachment-requirement-to-review
                   :process.signal/add-attachment-requirement)]
      {:db       (assoc-in db [::requirements :add-loading?] true)
       :dispatch [::process/signal
                  target-id
                  [signal (merge {:attachment-type attachment-type}
                                 (when review-id
                                   {:review-id review-id}))]
                  {:on-done  [::clear-add-loading]
                   :on-error [::clear-add-loading]
                   :notify   {:success :attachments/added}}]})))


(rf/reg-event-fx ::add-requirement-to-review
  (fn [_ [_ target-id requirement-id review-id]]
    {:dispatch [::process/signal
                target-id
                [:process.signal/add-requirement-to-review (util/mmap requirement-id review-id)]
                {:notify {:success :attachments/added}}]}))


(rf/reg-event-fx ::remove-requirement-from-review
  (fn [_ [_ target-id requirement-id review-id]]
    {:dispatch [::process/signal
                target-id
                [:process.signal/remove-requirement-from-review (util/mmap requirement-id review-id)]
                {:notify {:success :attachments/removed}}]}))


(rf/reg-event-fx ::remove-attachment-requirement
  (fn [{:keys [db]} [_ target-id attachment-type]]
    {:db       (assoc-in db [::requirements :remove-loading?] true)
     :dispatch [::process/signal
                target-id
                [:process.signal/remove-attachment-requirement {:attachment-type (:db/id attachment-type)}]
                {:on-success [::clear-remove-loading]
                 :on-error   [::clear-remove-loading]
                 :notify     {:success :attachments/removed}}]}))


(rf/reg-event-fx ::add-party-role-requirement
  (fn [_ [_ target-id party-role-id review-id]]
    (let [signal (if review-id
                   :process.signal/add-party-role-requirement-to-review
                   :process.signal/add-party-role-requirement)]
      {:dispatch [::process/signal
                  target-id
                  [signal (merge {:role-id party-role-id}
                                 (when review-id
                                   {:review-id review-id}))]
                  {:notify {:success :party-role-requirement/added}}]})))


(rf/reg-event-db ::clear-add-loading
  (fn [db _]
    (p/dissoc-in db [::requirements :add-loading?])))


(rf/reg-event-db ::clear-remove-loading
  (fn [db _]
    (p/dissoc-in db [::requirements :remove-loading?])))

(defn extract-session-id
  "Extracts session-id from Datomic tuple [attr-id value] for review or attachment"
  [data]
  (or (get-in data [:review/session-id 1])
      (get-in data [:attachment/session-id 1])))

(def review-session-confirmation-path [::requirements :session-confirmation])

(rf/reg-event-db ::clear-session-confirmation
  (fn [db _]
    (p/dissoc-in db review-session-confirmation-path)))

(rf/reg-event-fx ::review-integration-service.success
  (fn [{:keys [db]} [_ {:keys [entity-id provider]} _ success-data]]
    (when-let [session-id (and (= provider :bluebeam)
                               (extract-session-id (get success-data entity-id)))]
      {:db (assoc-in db review-session-confirmation-path
                     {:session-id session-id
                      :web-url    (plan-review-integration-model/bluebeam-session-url session-id)
                      :studio-url (plan-review-integration-model/bluebeam-studio-url session-id)})})))

(rf/reg-event-fx ::reload-application.success
  (fn [{:keys [db]} _]
    (when-let [workspace-id (get-in db [:view/workspace :workspace/id])]
      {:dispatch [::ws-get/get-for-application-view workspace-id]})))

(rf/reg-event-fx ::navigate-to-oauth-url
  (fn [_ [_ oauth-url]]
    {:navigate-to oauth-url}))

(rf/reg-event-fx ::review-integration-service
  (fn [_ [_ {:keys [application-id provider type entity-id attachment-type?]}]]
    (let [signal (case type
                   :markup     (if attachment-type?
                                 [:process.signal/attachment-lock-and-push-for-external-editing (util/mmap {:attachment-id entity-id} provider)]
                                 [:process.signal/review-open-external-tool (util/mmap {:review-id entity-id} provider)])
                   :end-markup (if attachment-type?
                                 [:process.signal/attachment-unlock-and-pull-from-external-editing (util/mmap {:attachment-id entity-id} provider)]
                                 [:process.signal/review-return-from-external-tool (util/mmap {:review-id entity-id} provider)])
                   nil)
          opts   (case type
                   :markup     {:on-success [::review-integration-service.success (util/mmap entity-id provider)]}
                   :end-markup {:on-success [::reload-application.success]}
                   nil)]
      (when signal
        {:dispatch [::process/signal application-id signal opts]}))))

(def review-integration-storage-key "review-integration-storage-key")

(rf/reg-event-fx ::review-bluebeam-authentication.success
  (fn [{:keys [db]} [_ _ {:keys [redirect-url]}]]
    (let [review-config    (get db ::pending-review-integration)
          new-db           (dissoc db ::pending-review-integration)
          attachment-type? (eu/is-type? :entity.type/attachment (:entity review-config))
          entity-id        (-> review-config :entity :db/id)
          service-config   (merge (dissoc review-config :entity)
                                  (util/mmap attachment-type? entity-id))]
      (if (nil? redirect-url)
        {:db       new-db
         :dispatch [::review-integration-service service-config]}
        {:db                 new-db
         :local-storage-set! [review-integration-storage-key service-config]
         :dispatch           [::navigate-to-oauth-url redirect-url]}))))

(rf/reg-event-fx ::verify-review-integration-from-storage
  (fn [_ _]
    (p/if-all-let [stored                  (futil/local-storage-get review-integration-storage-key)
                   review-integration-data (try
                                             (edn/read-string {:readers {}} stored)
                                             (catch :default _ nil))]
      {:dispatch           [::review-integration-service review-integration-data]
       :local-storage-set! [review-integration-storage-key nil]})))

(rf/reg-event-fx ::review-bluebeam-authentication
  (fn [{:keys [db]} [_ review-config]]
    {:db       (assoc db ::pending-review-integration review-config)
     :dispatch [:comm/command-monitored
                {:command    :user/set-bluebeam-authentication
                 :method     :post
                 :on-success [::review-bluebeam-authentication.success]}]}))
